var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.order.orderStatus === _vm.orderStatus.paymentOpen ||
      _vm.orderStatus.paymentRefused
    )?_c('CheckoutOpen',{attrs:{"order":_vm.order,"next-step":_vm.nextStep}}):_vm._e(),(_vm.order.orderStatus === _vm.orderStatus.paymentPending)?_c('CheckoutPending',{attrs:{"order":_vm.order}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }